<!-- =========================================================================================
  File Name: PromoView.vue
  Description: Promo selection in order
  ----------------------------------------------------------------------------------------
  Item Name: C4 - Selection of promo in order confirmation
  Author: Oscar Ramírez O.
  Author URL: https://acentoNET.com
========================================================================================== -->


<template>
  <vs-popup fullscreen :active.sync="isPromoActiveLocal" title="Seleccione descuento">
    <div class="flex flex-wrap items-center justify-between ag-grid-table-actions-right">
      <vs-input class="mb-4 md:mb-0 mr-4" v-model="searchQuery" @input="updateSearchQuery" placeholder="Buscar..."/>
    </div>
      <ag-grid-vue style="width: 100%; height: calc(100vh - 17rem);"
        :gridOptions="gridOptions"
        class="ag-theme-material w-full ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="$store.state.promos"
        rowSelection="single"
        colResizeDefault="shift"
        :animateRows="true"
        :floatingFilter="false"
        :pagination="false"
        :paginationPageSize="paginationPageSize"
        :suppressPaginationPanel="true"
      >
      </ag-grid-vue>
<!--    </div>-->
      <div class="flex justify-end" style="position: absolute; bottom: 40px; right: 45px;">
        <vs-button icon-pack="feather" icon="icon-check" class="mr-2" @click="acceptPromo">ACEPTAR</vs-button>
        <vs-button icon-pack="feather" icon="icon-x" color="danger" @click="closePromo">CANCELAR</vs-button>
      </div>
  </vs-popup>
</template>

<script>
  import VuePerfectScrollbar from 'vue-perfect-scrollbar'
  import {AgGridVue} from "ag-grid-vue"
  import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'

  export default {
    props: {
      id: {
        code: '',
        name: '',
      },
      isPromoActive: {
        type: Boolean,
        required: true
      }
    },
    data() {
      return {
        data: {
          code: '',
          name: ''
        },
        searchQuery: '',
        gridOptions: {
          localeText: {noRowsToShow: 'No se encontraron descuentos o alianzas'},
          suppressCsvExport: true,
          floatingFilter: true,
          context: {
            products: []
          },
          onRowDoubleClicked: this.rowDoubleClicked
        },
        maxPageNumbers: 7,
        gridApi: null,
        gridColumnApi: null,
        defaultColDef: {
          sortable: true,
          editable: false,
          resizable: true,
          suppressMenu: true
        },
        columnDefs: [
          {
            headerName: 'Descripcion',
            field: 'name',
            filter: true,
          },
          {
            headerName: 'Tipo',
            valueGetter: function(params) {
              return (params.data.type == 'PERCENT' ? 'Porcentaje' : 'Precio');
            }
          },
          {
            headerName: 'Valor',
            valueFormatter: amountRenderer,
            type: "numericColumn" ,
            valueGetter: function(params) {
              return (params.data.type == 'PERCENT' ? params.data.percent : params.data.price);
            }
          },
          {
            headerName: 'Producto',
            filter: true,
            valueGetter: function(params) {
              var ret = '';
              if (params.data.productId != '') {
                var product = params.context.products.find(p => p.id == params.data.productId);
                if (product) {
                  ret = product.name;
                }
              }
              return ret;
            }
          }
        ],
        selected: [],
        settings: { // perfectscrollbar settings
          maxScrollbarLength: 60,
          wheelSpeed: .60,
        },
      }
    },
    components: {
      VuePerfectScrollbar,
      AgGridVue,
    },
    // beforeMount() {
    //   this.gridOptions = {
    //     localeText: {noRowsToShow: 'No se encontraron descuentos o alianzas'},
    //     suppressCsvExport: true,
    //       onRowDoubleClicked: this.rowDoubleClicked
    //   };
    //   this.columnDefs = [
    //     {
    //       headerName: 'Descripcion',
    //       field: 'name',
    //       width: 250,
    //       filter: true,
    //     },
    //     {
    //       headerName: 'Tipo',
    //       field: 'type',
    //       width: 100,
    //     },
    //     {
    //       headerName: 'Valor',
    //       field: 'percent',
    //       valueFormatter: amountRenderer,
    //       type: "numericColumn" ,
    //       width: 120,
    //     },
    //     {
    //       headerName: 'Producto',
    //       field: 'productId',
    //       width: 200,
    //       filter: true,
    //     }
    //   ];
    //   this.defaultColDef = {
    //     sortable: true,
    //       editable: false,
    //       resizable: true,
    //       suppressMenu: true
    //   };
    // },
    computed: {
      isPromoActiveLocal: {
        get() {
          return this.isPromoActive
        },
        set(val) {
          if (!val) {
            this.$emit('closePromoSidebar');
          }
        }
      },
      paginationPageSize() {
        if(this.gridApi) return this.gridApi.paginationGetPageSize();
        else return 50
      },
      totalPages() {
        if(this.gridApi) return this.gridApi.paginationGetTotalPages();
        else return 0
      },
      currentPage: {
        get() {
          if(this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
          else return 1;
        },
        set(val) {
          if (this.gridApi) {
            this.gridApi.paginationGoToPage(val - 1);
          }
        }
      }
    },
    watch: {
      isPromoActiveLocal: function () {
        if (this.isPromoActiveLocal) {
          this.gridOptions.context.products = this.$store.state.products;
          this.gridApi.sizeColumnsToFit();
          this.data = this.id;
          this.initValues;
        }
      }
    },
    mounted() {
      this.gridApi = this.gridOptions.api;
      this.gridColumnApi = this.gridOptions.columnApi;
    },
    methods: {
      initValues() {
        this.id.code = '';
        this.id.name = '';
        this.id.type = '';
        this.id.percent = 0;
        this.id.value = 0;
        this.id.productId = '';
      },
      onFirstDataRendered(params) {
        params.api.sizeColumnsToFit();
      },
      autoSizeAll() {
        var allColumnIds = [];
        this.gridColumnApi.getAllColumns().forEach(function(column) {
          allColumnIds.push(column.colId);
        });
        this.gridColumnApi.autoSizeColumns(allColumnIds);
      },
      onGridReady() {
        // this.autoSizeAll();
        this.gridApi.sizeColumnsToFit();
      },
    numericFormat(value, decimals) {
        var ret = value;
        if (typeof value !== 'undefined') {
          ret = value.toFixed(decimals).replace(/\d(?=(\d{3})+\.)/g, '$&,');
        }
        return ret;
      },
      getType(type) {
        return (type == 'PERCENT' ? 'Porcentaje' : 'Precio');
      },
      getProduct(productId) {
        var ret = '';
        if (productId > 0) {
          var product = this.$store.state.products.find(p => p.id == productId);
          if (product) {
            ret = product.name;
          }
        }
        return ret;
      },
      updateSearchQuery(val) {
        this.gridApi.setQuickFilter(val);
      },
      acceptPromo() {
        var selectedRows = this.gridApi.getSelectedRows();
        if (selectedRows.length > 0) {
          this.id.code = selectedRows[0].code;
          this.id.name = selectedRows[0].name;
          this.id.type = selectedRows[0].type;
          this.id.percent = selectedRows[0].percent;
          this.id.price = selectedRows[0].price;
          this.id.productId = selectedRows[0].productId;
          this.closePromo();
        }
      },
      closePromo() {
        this.isPromoActiveLocal = false;
        this.$emit('applyPromo');
      }

    }
  }

  function amountRenderer(amount) {
    return amount.value.toFixed(2);
  }
</script>

<style lang="scss" scoped>
  .add-new-data-sidebar {
    /deep/ .vs-sidebar--background {
      z-index: 52010;
    }

    /deep/ .vs-sidebar {
      z-index: 52010;
      width: 400px;
      max-width: 90vw;

      .img-upload {
        margin-top: 2rem;

        .con-img-upload {
          padding: 0;
        }

        .con-input-upload {
          width: 100%;
          margin: 0;
        }
      }
    }
  }

  .scroll-area--data-list-add-new {
    height: calc(100% - 4.3rem);
  }

  .scroll-area--customizer {
    position: relative;
    margin: auto;
    width: 100%;
    height: calc(100% - 4.3rem);
  }
</style>
